import { render, staticRenderFns } from "./PartsListGrid.vue?vue&type=template&id=aa27ff10"
import script from "./PartsListGrid.ts?vue&type=script&lang=ts&external"
export * from "./PartsListGrid.ts?vue&type=script&lang=ts&external"
import style0 from "./PartsListGrid.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports